const CONSTANTS = {
    // baseUrl: "http://localhost:1337",
    // createUrl: (url) => "http://localhost:1337" + url,
    baseUrl: "https://api.jaipurpinkpanthers.com",
    createUrl: (url) => "https://api.jaipurpinkpanthers.com" + url,
};
export default CONSTANTS